export const globalStyles = {
    palette: {
        primaryColor: {
            main: '#273358'
        },
        secondaryColor: {
            main: '#007FA8'
        }
    }
};
